// Sidebar.js - Modern Design

import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Logo from '../assests/Upjao_logo.png';
import PromoCard from '../assests/promo_card.png';
import Header from './Header';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';

const routes = [
  { path: "/scan", name: "Scan", icon: <DocumentScannerOutlinedIcon sx={{ height: 20, width: 20 }} /> },
  { path: "/scan_history", name: "Scan History", icon: <ManageHistoryIcon sx={{ height: 20, width: 20 }} /> },
  { path: "/scan_video", name: "How To Scan", icon: <VideocamOutlinedIcon sx={{ height: 20, width: 20 }} /> },
];

const MOBILE_BREAKPOINT = 768;

const Sidebar = ({ children }) => {
  const location = useLocation();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= MOBILE_BREAKPOINT : false
  );

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (mobile) {
        setIsCollapsed(false);
      } else {
        setIsMobileSidebarOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuClick = () => {
    if (isMobile) {
      setIsMobileSidebarOpen((prev) => !prev);
    } else {
      setIsCollapsed((prev) => !prev);
    }
  };

  const currentRoute = routes.find((r) =>
    location.pathname === r.path || location.pathname.startsWith(r.path + "/")
  );
  const currentTabName = currentRoute?.name || "";

  const sidebarClassName = [
    "modern_sidebar",
    isMobileSidebarOpen ? "modern_sidebar_open" : "",
    isCollapsed ? "collapsed" : "",
  ].filter(Boolean).join(" ");

  return (
    <div className="modern_sidebar_wrapper">
      {/* Sidebar */}
      <aside className={sidebarClassName}>
        {/* Logo Section */}
        <div className="modern_logo_section">
          <img src={Logo} alt="Upjao logo" className="modern_logo" />
          <img src="/favicon.ico" alt="Upjao" className="modern_logo_collapsed" />
        </div>

        {/* Divider */}
        <div className="modern_divider"></div>

        {/* Navigation Menu */}
        <nav className="modern_menu">
          {routes.map((route, index) => (
            <NavLink
              key={index}
              to={route.path}
              className={({ isActive }) =>
                `modern_menu_item ${isActive ? "active" : ""}`
              }
              onClick={() => setIsMobileSidebarOpen(false)}
            >
              {({ isActive }) => (
                <>
                  <span className="modern_menu_icon">{route.icon}</span>
                  <span className="modern_menu_text">{route.name}</span>
                  {isActive && <div className="modern_active_indicator"></div>}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* Promo card */}
        <div className="modern_promo_card">
          <img src={PromoCard} alt="Driving Quality, Empowering Growth" className="modern_promo_img" />
        </div>

        {/* Footer */}
        <div className="modern_footer">
          <p>© 2026 UPJAO</p>
          <p>All rights reserved</p>
        </div>
      </aside>

      {/* Backdrop for mobile, closes sidebar when tapped outside */}
      {isMobileSidebarOpen && (
        <div
          className="modern_sidebar_backdrop"
          onClick={() => setIsMobileSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <main className={`modern_main_content ${isCollapsed ? "modern_main_content_collapsed" : ""}`}>
        <Header pageTitle={currentTabName} onMenuClick={handleMenuClick} />
        <div className="modern_page_body">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Sidebar;